export const Bio = {
  name: "Sujal Chandrakar",
  roles: [
    "Full Stack Developer",
    "LLM Developer",
    "Frontend Developer",
    "Backend Developer",
  ],
  description:
    "A passionate full-stack developer with a knack for building scalable, user-friendly web applications. With expertise in modern frameworks like React, Next.js, Node.js and LLM, I specialize in crafting seamless user experiences and robust backend systems.",
  github: "https://github.com/sujalforselfuse",
  resume:
    "https://drive.google.com/file/d/10gL8GigYyZPS0tP5e9w_2n2CYlEH_-j8/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sujal-chandrakar",
  insta: "https://www.instagram.com/sujal_chandrakar/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Tailwind",
        image:
          "https://img.icons8.com/color/48/tailwind_css.png",
      },
      {
        name: "TypeScript",
        image:
          "https://img.icons8.com/color/48/typescript.png",
      },

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "ChromaDB",
        image:
          "https://miro.medium.com/v2/resize:fit:793/0*RTW5byy6eH_eSWTP.png",
      },
      {
        name: "Neo4j",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAADp0lEQVR4nKWWTWwTRxTH3QOHqoJDkcqsd6EgekAFpEocipSNTbqWSlUkUPAa06LYyoFUoodKQOzEG0wqxGySmgrIx8aJ7YCc+APPJiQBJZkpF2igKqIXCqlKFakqEoFWqoLaEEK81caxdze2g60+6R1mD//f/N+8ebMm04pwRiwjvMS+csvcjEvm2nYHAm8DIXWcOj3UxkAsMCL5khYnqs1n8XpTueHss3bbuyoUNd2ybSn3RdydoL5fofyDYRqSB4xIlEziBRriCbqFVJUMcPRWzqwEuBH3gGqI/7VRuLqdEXGSaSEHaBG3Z0G0SP5mIDlWGiBUOZ0PsE0Cz8C8uUnOCn5FQxJ9rzWJPpWcvzi6K+edfZVzbsT95EJc0+fX964rCrC2f+G1SxrAJXOLO1sv9oL6qKIB8Jy143iI76pIZzdzuM+q39CjGrlqa564+RQ6ptZ6y9eRyX1S9c/OxP7w1jMRBOr703rA+4FIp13SxPMAmbx/tHvXGgOAaog/V4WAN/YSeAdeAE9UWVovpwqgIf73YOijKb14EYBSg7gaTVxIHcgKUadQs1mQa/XiIAsQ8V2+u2KhFIBbtkX1gFFNbGAReGLzhQCMSDC/ojzFAC6ZG9MAjcnpnJjvygTwpywFARBP8cGKuZIcIC6YA4DGxLOcmDf2D+W7MlXEgbK/p/p2SQ4Qt1fnIP40J+aJKpSQSgJvbK4QYLM4eo0Psi9XA7iQbcTQQaAx+VAnlgbNw1bQkPyjEEDNbYHLl/kg+6IQwBHnxzfBsYSxRYVUeGVJgHouXs2FHpDJCcx11g3yIcujzy5Z7x9KHOzZcT7SwYjkT0bEd4yXzJ/8gPL0GwC0H+2mfGg4W7Z8QHYW4ScMxDcYkSzmvkN8Mu8mU42J3wwOPP1p2jfw654Ldff4Hsv0kdQnIVY662dEMmmAQCxsaBt/i4HkVWZNZta33FqbB9jUNLiL8kTT2R1vO9N+g5fYTM9L2vBzDX58fSPEY8uDL0RD8iMD8fc5R/A7vsCYW3bhk88tAYT473aJXcx1ig6gZnXsSHBpTAcm32REck7n5tui4rnzEOTeD7/xGHtdMgJcyDZLi/gmA/GstnPSYVKUN0ylxKGw5YfVAG7ZpmxpHY4tv2zPaZHUmcoJZ9gy8hoHC5tbR0/QEJ/e0Db+jqnccESrLPYudhUH3NWyRfMgERYVArgQ97g2VfXu/wao4eyzNjuC7Kz6gqm/MW5k660dspnLEfkPzhppgWrYu1MAAAAASUVORK5CYII=",
      },
      {
        name: "Nginx",
        image:
          "https://img.icons8.com/color/48/nginx.png",
      },

    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Large Language Models",
        image: "https://th.bing.com/th/id/OIP.vavoc8cDEEF29H7bX8kxjQHaHa?w=179&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7",
      },
      {
        name: "Socket IO",
        image:
          "https://socket.io/images/logo-dark.svg",
      },
      {
        name: "MapBox",
        image: "https://www.pngrepo.com/download/331476/mapbox.png",
      },

      {
        name: "Payment Gateway",
        image:
          "https://cdn-images-1.medium.com/max/184/1*NKfnk1UF9xGoR0URBEc6mw@2x.png",
      },
      {
        name: "Optimal Character Recognition (OCR)",
        image:
          "https://images-eu.ssl-images-amazon.com/images/I/610%2BoNN1IlL.png",
      },

    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://img.icons8.com/color/48/git.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://img.icons8.com/pulsar-color/48/postman-api.png",
      },
      {
        name: "Jira",
        image:
          "https://img.icons8.com/color/48/jira.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/6c/28/75/6c28759e-0b6c-7eb0-1524-493cdc879e4c/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/246x0w.webp",
    role: "Fullstack Engineering Intern",
    company: "Infloso AI - Social Media Copilot",
    date: "June 2024 - Dec 2024",
    desc: "Worked on the Molly Chatbot which can automate and process all the brand needs, From creating a automating google ads crafting,seo audit, finance reports to getting tips to imporve brand presence. I also worked on the infloso webapp where I have added new features and improved the existing ones.",
    skills: [
      "NextJs",
      "NodeJs",
      "LLM :- OpenAI + Gemini + Perplexity",
      "Tailwind",
      "Docket",
      "Nginx",
      "JavaScript",
      "TypeScript",
    ],

  },
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D4D0BAQF8sVTdm-r9dQ/company-logo_200_200/company-logo_200_200/0/1730701629322?e=1741824000&v=beta&t=ln40LHKCR_BKnodVT0fm-9rdCiwxBpwrwCSrCCeojOA",
    role: "Fullstack Engineering Intern",
    company: "MechBuddy",
    date: "July 2023 - Oct 2023",
    desc: "Worked on the both frontend and backend of the website where I crafted the website from the scratch.",
    skills: [
      "ReactJS",
      "NodeJs",
      "Tailwind",
      "HTML",
      "CSS",
      "JavaScript",
      "Razorpay",
    ],
    doc: ["https://media.licdn.com/dms/image/v2/D4D2DAQEsUCsOmZKCbA/profile-treasury-image-shrink_1920_1920/profile-treasury-image-shrink_1920_1920/0/1701288512212?e=1734206400&v=beta&t=MltREclAir9tmvN3T8S6g6P-_hnnHFrrX0H6p5aHef0"],
  },


];

export const education = [
  {
    id: 0,
    img: "https://media.glassdoor.com/sqll/513138/mits-squarelogo-1504254088107.png",
    school: "Madhav Institute of Technology and Science, Gwalior",
    date: "July 2021 - May 2025",
    grade: "8.47 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Madhav Institute of Industrial Technology and Science, Gwalior. I have completed courses in Data Structures, Algorithms, Operating Systems, and Database Management Systems.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://th.bing.com/th/id/OIP.WfVcUfqwA28e2EL2F3c9ZAHaGA?rs=1&pid=ImgDetMain",
    school: "Vinay Bal Mandir, Khargone",
    date: "Apr 2019 - May 2021",
    grade: "87.2%",
    desc: "I completed my class 12 high school education at Vinay Bal Mandir, where I studied Physics, Chemistry with Mathematics",
    degree: "MP Board (PCM)",
  },
  {
    id: 2,
    img: "https://play-lh.googleusercontent.com/LNRIa9HMyuxNyv0li0WINX0ALMohECxPDu77NWRjP2JZCUsxDbukylfgmqj2RcrX7o8=w220",
    school: "The Creative Public Higher Secondary School, Khargone",
    date: "Apr 2006 - Mar 2019",
    grade: "90%",
    desc: "I completed my class 10 education at The Creative Public Higher Secondary School",
    degree: "CBSE (X)",
  },
];

export const projects = [

  {
    id: 0,
    title: "Sankat Sarthi",
    date: "Nov 2023",
    description:
      "Developed an application to assist in escaping calamities during disasters.",
    image:
      "https://i.ibb.co/4SxyY5m/Screenshot-2024-12-08-034911.png",
    tags: [
      "React Js",
      "Node Js",
      "MongoDb",
      "MapBox",
      "Raazorpay"
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/sankat_sarthi",
    webapp: "https://sankat-sarthi.netlify.app/",
  },
  {
    id: 0,
    title: "Ingredient IQ",
    date: "Feb 2024",
    description:
      "Developed an application that scans food item ingredients to assess their healthiness",
    image:
      "https://i.ibb.co/1qbq0HM/Screenshot-2024-12-08-035311.png",
    tags: [
      "React Js",
      "Node Js",
      "OCR",
      "LLM/Gemini",
    ],
    category: "llm app",
    github: "https://github.com/sujalforselfuse/ingredient-iq-backend",
    webapp: "https://6659a85ee7f811133fef4d2e--elaborate-donut-003f18.netlify.app/",
  },
  {
    id: 0,
    title: "GFG MITS Chapter",
    date: "Feb 2024",
    description:
      "Developed a website for the GeeksforGeeks MITS Chapter, a student organization that provides resources and opportunities for students to learn and grow. The website features a blog, event calendar, and resources for students to learn and practice coding.",
    image:
      "https://i.ibb.co/mJvB9nT/Screenshot-2024-12-08-022120.png",
    tags: [
      "React Js",
      "Tailwind",
      "Zustand",
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/gfg-mits",
    webapp: "https://gfg-mits.netlify.app/",
  },
  {
    id: 1,
    title: "Ratna Ayurveda Eccomerce Site",
    date: "July 2024",
    description:
      "Developed a website for Ratna Ayurveda, a company that sells Ayurvedic products. The website features a product catalog, shopping cart, OTP verification, and payment integration. Implemented a custom CMS for the client to manage products and orders.",
    image:
      "https://i.ibb.co/mBr2d8f/Screenshot-2024-12-08-022907.png",
    tags: [
      "React Js",
      "Node Js",
      "MongoDb",
      "Raazorpay",
      "Message Central",
      "Tailwind",
      "Zustand",
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/ratna-backend",
    webapp: "https://ratna-ayurveda.netlify.app/",
  },
  {
    id: 2,
    title: "Ratna Ayurveda Admin Panel",
    date: "July 2024",
    description:
      "Developed an admin panel for Ratna Ayurveda, a company that sells Ayurvedic products. The admin panel features a dashboard, product management, order management, and user management. Implemented a custom CMS for the client to manage products and orders.",
    image:
      "https://i.ibb.co/k34mGXQ/Screenshot-2024-12-08-030358.png",
    tags: [
      "React Js",
      "Node Js",
      "MongoDb",
      "Tailwind"
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/ratna-backend",
    webapp: "https://github.com/sujalforselfuse/ratna-ayurveda-admin",
  },
  {
    id: 3,
    title: "Emoji Describer",
    date: "Aug 2024",
    description:
      "Developed an npm package that provides a description of emojis. The package can be used in any JavaScript project to get a description of an emoji. The package is published on npm and can be installed using npm install emoji-describer. It has over 1000 downloads.",
    image:
      "https://i.ibb.co/KDFfz1j/Screenshot-2024-12-08-023618.png",
    tags: [
      "Node Js",
      "npm",
      "JavaScript",
    ],
    category: "npm package",
    github: "https://github.com/sujalforselfuse/emoji-describer",
    webapp: "https://www.npmjs.com/package/emoji-describer",
  },
  {
    id: 7,
    title: "Google Clone App",
    date: "Nov 2022",
    description:
      "Developed a web app that allows users to search for websites using the Google Search API. Users can view search results and visit websites. ",
    image:
      "https://i.ibb.co/f8Lj1dC/Screenshot-2024-12-08-034305.png",
    tags: [
      "Node Js",
      "React Js",
      "Google Search API"   
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/google-clone",
    webapp: "https://google-project-sujal.netlify.app/",
  },
  {
    id: 4,
    title: "Scribe Pad",
    date: "Aug 2022",
    description:
      "Developed a web app that allows users to write and save notes. The app features a rich text editor. Users can create an account to save their notes and access them from any device.",
    image:
      "https://i.ibb.co/b5tp5Wz/Screenshot-2024-12-08-031722.png",
    tags: [
      "Node Js",
      "React Js",
      "MongoDb",
      "Tailwind"      
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/notevault",
    webapp: "https://scribe-pad.netlify.app/",
  },  
  {
    id: 6,
    title: "Automobile Service Center",
    date: "Aug 2023",
    description:
      "Developed a web app for an automobile service center.",
    image:
      "https://i.ibb.co/CsPYddK/Screenshot-2024-12-08-033606.png",
    tags: [
      "React Js",
      "Tailwind",
      "Html",
      "CSS",     
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/mechbuddy",
    webapp: "https://automobile-service-sujal.netlify.app/",
  },
  {
    id: 5,
    title: "Chat App",
    date: "Oct 2022",
    description:
      "Developed a web app that allows users to chat with each other in real-times. Users can create chat rooms and invite others to join. It only shows the demonstration of my socket io skills . Please ignore the UI.",
    image:
      "https://i.ibb.co/sw1ZTRq/Screenshot-2024-12-08-033123.png",
    tags: [
      "Node Js",
      "Socket IO",
      "Html",
      "CSS",     
    ],
    category: "web app",
    github: "https://github.com/sujalforselfuse/chatappbackend",
    webapp: "https://sujal-chat-web.netlify.app/",
  },
  
  
  ];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
